export type TwoFactorPayload = {
  code?: string;
};

export type TwoFactorSecretPayload = {
  secret: string;
};

export type TwoFactorSecretPayloadModel = {
  qr: string;
  link: string;
  secretKey: string;
};

export const authErrorCodes = [401, 419];
export const authForbiddenCode = 403;
